import React from "react";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";

export const Contact = () => {
  const socialLinks = [
    {
      icon: <FaLinkedin />,
      title: "LinkedIn",
      url: "https://www.linkedin.com/in/2361am/",
      className: "bg-gradient-to-r from-blue-600 via-blue-500 to-blue-400",
    },
    {
      icon: <FaGithub />,
      title: "GitHub",
      url: "https://github.com/anuragbhardwaj21",
      className: "bg-gradient-to-r from-gray-600 to-gray-700",
    },

    {
      icon: <FaInstagram />,
      title: "Instagram",
      url: "https://www.instagram.com/23.61.am/",
      className:
        "bg-gradient-to-r from-[#f58529] via-[#dd2a7b] via-[#8134af] to-[#515bd4]",
    },
    {
      icon: <FaYoutube />,
      title: "YouTube",
      url: "https://www.youtube.com/@gigachadlivee/",
      className: "bg-gradient-to-r from-red-600 to-red-500",
    },
  ];

  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="md:h-[79%] h-[50%] w-full"></div>
      <div className="md:h-[10%] w-full flex flex-col md:flex-row text-shade-2 dark:text-shade-4">
        {socialLinks.map((link, index) => (
          <p
            key={index}
            className={`w-full h-full ${link.className} cursor-pointer hover:brightness-75 flex items-center justify-between px-4`}
            onClick={() => window.open(link.url, "_blank")}
          >
            <span className="md:text-3xl text-md uppercase font-medium">{link.title}</span>
            <span className="text-6xl">{link.icon}</span>
          </p>
        ))}
      </div>
      <p className={`text-shade-2 dark:text-shade-4 w-full md:h-[7%] h-[5%] bg-gradient-to-r from-green-600 via-green-500 to-green-400 cursor-pointer hover:brightness-75 flex items-center md:justify-center justify-between gap-4 px-4`}
        onClick={() =>
          window.open("mailto:anuragbhardwaj1234@gmail.com", "_blank")
        }
      >
        <span className="md:text-3xl text-md uppercase font-medium">
          Shoot me an email
        </span>
        <span className="text-6xl">
          <IoIosMail />
        </span>
      </p>
      <p className="text-green-400 w-full md:h-[4%] h-[5%] bg-shade-4 dark:bg-shade-2 cursor-pointer flex items-center justify-center select-none">
        <span className="md:text-xl text-sm uppercase font-medium">
          Made with ❤️ by Anurag Bhardwaj
        </span>
      </p>
    </div>
  );
};
